import { createFileRoute } from "@tanstack/react-router";

import { ConnectionsPageSkeleton } from "@/components/pageSkeletons";
import {
  ConnectionsLoadError,
  ConnectionsPage,
} from "@/connections/ConnectionsPage";
import { pageTitle } from "@/i18n/title";
import { query } from "@/queries";

export const Route = createFileRoute("/_authed/connections")({
  head: () => pageTitle("Connections"),
  // 'static' returns a cached list without blocking navigation. The page
  // observer still revalidates. Accounts only fill the assign field.
  loader: ({ context: { queryClient } }) => {
    void queryClient.query(query.customers.accounts()).catch(() => undefined);
    return queryClient.query({
      ...query.johnDeere.unassignedConnections(),
      staleTime: "static",
    });
  },
  pendingComponent: ConnectionsPageSkeleton,
  errorComponent: ConnectionsLoadError,
  component: ConnectionsPage,
});
